/* eslint-disable jsx-a11y/label-has-associated-control */
import { Paper } from '@mui/material'
import { useState, useRef, useId } from 'react'

import { DragDropFileItem } from '../dragDropFileItem/DragDropFileItem'
import { DragDropZone } from '../dragDropZone/DragDropZone'
import { useHandlers } from '../helpers/useHandlers'
import { TDragDropInput } from '../types'

import style from './DragDropInput.module.scss'

// поле для добавления файлов
export function DragDropInput(props: TDragDropInput) {
  const {
    fileList,
    allowedFormats,
    isError,
    labelName,
    helperTitle,
    errorText,
    helperText,
  } = props

  const [dragActive, setDragActive] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const uniqID = useId()

  const { handleDrop, handleChange, handleDrag, removeThumbnail } = useHandlers(
    {
      props,
      inputRef,
      setDragActive,
    },
  )

  return (
    <div
      className={style.fileUpload}
      id='file-upload'
      onDragEnter={e => handleDrag(e, true)}
      onDragOver={e => handleDrag(e, true)}
      onDrop={handleDrop}
    >
      {true && (
        <Paper elevation={0} className={style.name}>
          {labelName}
        </Paper>
      )}
      <input
        className={style.fileUploadInput}
        ref={inputRef}
        type='file'
        accept={allowedFormats}
        id={`input-file-upload-${uniqID}`}
        multiple
        onChange={handleChange}
      />

      <DragDropZone
        dragActive={dragActive}
        uniqID={uniqID}
        helperTitle={helperTitle}
        inputRef={inputRef}
      />

      {fileList && fileList?.length > 0 && (
        <div className={style.files}>
          {fileList.map((item, index) => (
            <DragDropFileItem
              key={item.id}
              item={item}
              index={index}
              removeThumbnail={removeThumbnail}
            />
          ))}
        </div>
      )}

      {dragActive && (
        <div
          className={style.fileUploadFile}
          id='drag-file-element'
          onDragEnter={e => handleDrag(e, true)}
          onDragLeave={e => handleDrag(e, false)}
          onDragOver={e => handleDrag(e, true)}
          onDrop={handleDrop}
        />
      )}
      {isError ? (
        <p className={style.errorText}>{errorText}</p>
      ) : (
        helperText && <p className={style.helperText}>{helperText}</p>
      )}
    </div>
  )
}
